import dashboardRoutes from "./admin";
import authRoutes from "./auth";

const routes = [
    ...dashboardRoutes,
    ...authRoutes
]

export default routes